import { render, staticRenderFns } from "./people-supporters.vue?vue&type=template&id=83961e6a&scoped=true&"
import script from "./people-supporters.vue?vue&type=script&lang=js&"
export * from "./people-supporters.vue?vue&type=script&lang=js&"
import style0 from "./people-supporters.vue?vue&type=style&index=0&id=83961e6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83961e6a",
  null
  
)

export default component.exports